module.exports = __webpack_public_path__ + "static/media/flag-selected.3df50529.svg";